// Copyright (c) Docugami, Inc. All rights reserved.

import { IDrawCommand, IRenderer, IRendererInput, Queries } from "../engine/Engine";
import { ResourceDependencies } from "../Resources";
import { ComponentId } from "sdv/engine/Component";
import { ViewComponent } from "sdv/components/ViewComponent";
import { Page } from "sdv/Page";
import { scaleValue } from "sdv/Space";

const dependencies: ResourceDependencies = ["viewPosition", "pageImages", "visiblePages"];

/**
 * Renders the pages images to the canvas if they are visible and the image is available
 */
export class PageRenderer implements IRenderer {
    get renderEnabled(): boolean { return true; }

    queries: Queries = {
        view: { types: [ComponentId.View] },
    }

    render(engine: IRendererInput): IDrawCommand[] {
        const viewComp = this.queries.view.query!.single()?.getComponent<ViewComponent>(ComponentId.View);
        if (!viewComp) {
            return [];
        }

        const values = engine.resources.values(dependencies);
        const commands: IDrawCommand[] = []
        for (const visiblePage of values.visiblePages!) {
            const image = values.pageImages![visiblePage.id];
            if (!!image?.complete) {
                commands.push(context => drawPage(visiblePage, image, context));
            }
        }

        return commands;
    }
}

function drawPage(page: Page, image: HTMLImageElement, context: CanvasRenderingContext2D): void {
    context.scale(page.scaleFactor, page.scaleFactor)
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.globalCompositeOperation = "destination-over";
    context.drawImage(image, 0, scaleValue(page.position.y, 1 / page.scaleFactor));
    context.globalCompositeOperation = "source-atop";
}
